import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';

import Areas from './accessProfiles/Areas';
import ClientView from './accessProfiles/ClientView';
import AccountManagement from './accessProfiles/AccountManagement';

const tabs = [
  { key: 'areas', label: 'ACESSO ÀS ÁREAS' },
  { key: 'client_view', label: 'ACESSO A CONTAS DE CLIENTES' },
  { key: 'account_management', label: 'GERENCIAMENTO DE CONTAS' },
];

const getInitialTab = () => {
  const tab = new URL(window.location.href).searchParams.get('tab');
  return tabs.some((item) => item.key === tab) ? tab : tabs[0].key;
};

const AccessProfiles = () => {
  const [activeTab, setActiveTab] = useState(getInitialTab);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    const url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    window.history.pushState({}, '', url);
  };

  return (
    <div className="flex min-h-full flex-col gap-5 p-0">
      <header className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between pt-6">
        <div className="flex items-center gap-3 px-6">
          <KeyRound className="text-tealMedium" size={22} strokeWidth={1.6} />
          <h1 className="text-2xl font-semibold text-blueDarker">Acessos e Permissões</h1>
        </div>

        <nav className="flex items-center gap-8 overflow-x-auto" aria-label="Seções de acessos e permissões">
          {tabs.map((tab) => {
            const active = activeTab === tab.key;

            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => handleTabChange(tab.key)}
                className={`whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-semibold transition-colors ${
                  active
                    ? 'border-tealMedium text-blueDarker'
                    : 'border-transparent text-blueSteel hover:text-blueDarker'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </header>

      {activeTab === 'areas' && <Areas />}
      {activeTab === 'client_view' && <ClientView />}
      {activeTab === 'account_management' && <AccountManagement />}
    </div>
  );
};

export default AccessProfiles;
